module.exports = __webpack_public_path__ + "static/media/badge_level_2_3.cf93b1f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_2_3.png
// module id = 514
// module chunks = 0